import { createSelector } from 'reselect'

import { selectBusinessPriorities } from './selectBusinessPriorities'
import { selectBusinessPrioritiesSelectedFYear } from './selectBusinessPrioritiesSelectedFYear'

// The selected FY is 0 until the JBP settings are loaded: show everything until then.
export const selectFilteredBusinessPriorities = createSelector(
  [selectBusinessPriorities, selectBusinessPrioritiesSelectedFYear],
  (records, fYear) => (fYear ? records.filter((record) => record.fYear === fYear) : records)
)
